import { Map, ExternalLink } from "lucide-react";
import { useLang } from "../i18n/LangContext";

const MAP_URL = '/images/bellin-1797-framed.jpg';
const FULL_URL = 'https://upload.wikimedia.org/wikipedia/commons/8/88/IAN_0134_Bellin_1797_Ionian_Sea.jpg';
const COMMONS_PAGE = 'https://commons.wikimedia.org/wiki/File:IAN_0134_Bellin_1797_Ionian_Sea.jpg';

export const MapSection = () => {
  const { d, ui } = useLang();
  return (
    <section id="oldmap" data-testid="oldmap-section" className="scroll-mt-24 border-b border-line py-20 md:py-28">
      <div className="mx-auto max-w-6xl px-6">
        <div className="mb-10 flex items-start gap-4">
          <div className="rounded-full bg-aegean p-3 text-paper">
            <Map className="h-5 w-5" />
          </div>
          <div>
            <p className="eyebrow">{ui.mapEyebrow}</p>
            <h2 className="mt-2 font-serif text-3xl md:text-4xl font-semibold tracking-tight text-ink">
              {ui.mapTitle}
            </h2>
            <p className="mt-3 max-w-3xl text-base md:text-lg leading-relaxed text-muted-foreground">
              {ui.mapDesc}
            </p>
          </div>
        </div>

        <div className="grid gap-8 lg:grid-cols-[1.4fr_1fr] lg:items-start">
          <figure className="overflow-hidden rounded-lg border border-line bg-paper">
            <a href={FULL_URL} target="_blank" rel="noopener noreferrer" data-testid="oldmap-fullsize-link">
              <img
                src={MAP_URL}
                alt="Karte von den Inseln St. Maura, Cephallenia, Zante — coloured engraving, German edition of Bellin, 1797"
                loading="lazy"
                className="w-full object-contain transition-transform duration-500 hover:scale-[1.02]"
              />
            </a>
            <figcaption className="flex flex-wrap items-center justify-between gap-2 border-t border-line bg-surface px-5 py-3">
              <span className="text-xs uppercase tracking-[0.15em] text-muted-foreground">
                J.-N. Bellin (German ed.), «Karte von den Inseln St. Maura, Cephallenia, Zante», 1797
              </span>
              <a
                href={COMMONS_PAGE}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="oldmap-source-link"
                className="inline-flex items-center gap-1 text-xs font-semibold text-aegean hover:text-terra"
              >
                Wikimedia Commons <ExternalLink className="h-3 w-3" />
              </a>
            </figcaption>
          </figure>

          <div>
            <h3 className="font-serif text-2xl font-semibold tracking-tight text-ink">
              {ui.mapLabelsTitle}
            </h3>
            <ul className="mt-6 space-y-5">
              {d.MAP_LABELS.map((l, i) => (
                <li key={l.old} className="border-l-2 border-line pl-5" data-testid={`oldmap-label-${i}`}>
                  <p className="font-serif text-lg font-semibold text-aegean">{l.old}</p>
                  <p className="text-sm font-semibold text-terra">= {l.modern}</p>
                  <p className="mt-1 text-sm leading-relaxed text-muted-foreground">{l.note}</p>
                </li>
              ))}
            </ul>
            <p className="mt-8 rounded-lg border border-terra/30 bg-terra/5 p-5 text-sm leading-relaxed text-foreground/85">
              <span className="font-semibold text-terra">{ui.mapWhyPrefix} </span>
              {ui.mapWhy}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
